<template>
  <SubLayout
      :pageTitle="title"
      :pageBreadcrumbs="breadcrumbs"
      :hasBack="true"
  >
    <template #subHeaderActions>
      <div class="d-flex align-items-center gap-2 gap-lg-3">

      </div>
    </template>

    <template #layoutContent>
      <div class="card shadow-sm">
        <form @submit.prevent="submitSurvey">
          <div class="card-header min-h-50px">
            <h2 class="card-title fs-1"></h2>
            <div class="card-toolbar">
              <!--            <button type="submit" class="btn py-2 btn-primary">
                            Créer une enquête
                          </button>-->
            </div>
          </div>
          <div class="card-body">

            <div class="row">
              <Input
                  containerClass="col-12 mb-6"
                  name="name"
                  :label="$t('label.title')"
                  :placeholder="$t('label.title')"
                  v-model="formData.name"
              />

              <div class="row">
                <div class="col-4">
                  <Input
                      containerClass="col-12 mb-6"
                      name="name"
                      :label="$t('label.population_question')"
                      :placeholder="$t('label.population_question')"
                      v-model="formData.questions"
                      :isRequired="false"
                  />
                </div>
                <div class="col-4">
                  <Select2
                      container-class="form-group col-12"
                      :multiple="true"
                      :show-search="true"
                      :selectClass="'form-select form-control-sm form-select-solid'"
                      :name="`populations${id}`"
                      :label="$t('label.population')"
                      labelClass="form-label fs-6 text-black"
                      :placeholderText="$t('label.population')"
                      v-model="formData.population_ids"
                      :IsInputGroup ="true"
                      :isRequired="false"
                      icon="bi bi-plus"
                      :clickAddon="openCreatePopulationModal">
                    <option v-for="population in populations" :key="population.id" :value="population.id">
                      {{ population.name }}
                    </option>
                  </Select2>


                </div>
                <div class="col-4 d-flex p-0">
                  <InputDate
                      size="lg"
                      id="start_date"
                      containerClass="col-6 mb-6 me-2 "
                      name="start_date"
                      :placeholder="$t('label.start_date')"
                      :label="$t('label.start_date')"
                      :minDate="minDate"
                      :isRequired="true"
                      v-model="formData.start_date"
                  />

                  <InputDate
                      size="lg"
                      containerClass="col-6 mb-6"
                      id="end_date"
                      name="end_date"
                      :placeholder="$t('label.end_date')"
                      :label="$t('label.end_date')"
                      :minDate="minDate"
                      v-model="formData.end_date"
                  />
                </div>
              </div>

              <TextArea
                  :label="$t('label.description')"
                  :placeholder="$t('label.description')"
                  :rows="3"
                  :isRequired="false"
                  v-model="formData.description"
              />

              <CreateQvctPopulations
                  id="create_qvct_population"
                  @reload="reload"
              />
            </div>
          </div>
          <div class="card-footer py-3 d-flex justify-content-end">
            <button type="submit" class="btn py-2 btn-light me-4">
              {{ $t('button.close') }}
            </button>

            <Button :is-loading="isLoading" type="submit" btnClass="btn py-2 btn-primary" :btn-text="$t('button.save')"/>
          </div>
        </form>
      </div>
    </template>
  </SubLayout>
</template>

<script setup>
import SubLayout from "@/views/Layouts/partials/SubLayout.vue";
import {computed, onMounted, ref} from "vue";
import {useStore} from "vuex";
import Button from "@/components/Button.vue";
import Input from "@/components/Input.vue";
import Select2 from "@/components/Select2.vue";
import InputDate from "@/components/InputDate.vue";
import {formatDate} from "@/mixins/Helpers";
import TextArea from "@/components/TextArea.vue";
import {useRouter} from "vue-router";
import CreateQvctPopulations from "@/Modules/Qvct/components/CreateQvctPopulations.vue";

const router = useRouter()

const store = useStore()

const title = ref('qvct_survey.survey.create')

const breadcrumbs = ref([
  {
    name: 'navigation.dashboard',
    route: 'home-path'
  },
  {
    name: 'navigation.qvct_survey',
    route: 'qvct-survey-index'
  },
  {
    name: 'navigation.qvct_survey_create',
    path: 'qvct-survey-create'
  }
])

const formData = ref({
  name: "",
  questions: "",
  start_date: "",
  end_date: "",
  description: "",
  population_ids :[]
})

const minDate = formatDate(new Date())

const isLoading = ref(false)

const populations = computed(() => store.getters['qvctPopulation/getQvctpPopulations'])

function addQuestion() {
  formData.value.fields.push({
    type: 'radio',
  })
}


function openCreatePopulationModal(){
  $('#kt_modal_create_qvct_population').modal('toggle')
}

function reload(population){
  loadData()
  formData.value.population_ids.push(population)
}
function submitSurvey() {
  isLoading.value = true

  store.dispatch('qvctSurvey/storeSurvey', formData.value)
      .then((response) => {
        window.toastr.success(i18n.global.t('qvct_survey.message.survey_created_successfully'))
        isLoading.value = false

        router.push({
          name: 'qvct-survey-view',
          params: {
            id: response.data.survey.id
          }
        })

      })
      .catch(() => {
        isLoading.value = false
      })
}

function loadData() {
  Promise.all([
    store.dispatch('qvctPopulation/loadQvctPopulation'),
  ])
}


onMounted(() => {
  loadData()
})

</script>

<style scoped>

</style>